import focusTrap from '../../modules/focusTrap';

/**
 * Mobile Navigation Object
 * Used to trigger events on the menu
 */
const mobileNav = {
	body: document.body,
	menuToggle: document.getElementById('menuToggle'),
	closeBtn: document.querySelector('button.mobile-nav--close'),
	nav: document.querySelector('.mobile-nav'),
	wrap: document.querySelector('.mobile-nav--wrap'),
	subMenus: document.querySelectorAll('.mobile-nav ul.sub-menu'),

	// Loop Mobile Menu to add toogle buttons
	setUpSubmenus: function (menus) {
		[...menus].forEach((menu) => {
			let p = menu.parentNode; // Parent `<li/>`
			let button = document.createElement('button');
			button.classList.add('a11ydrops-btn');
			button.innerHTML = '<span class="offscreen">Toggle Menu</span>';
			// Set aria attributes
			if (
				p.classList.contains('current_page_ancestor') ||
				p.classList.contains('current-menu-item')
			) {
				// Open
				button.setAttribute('aria-expanded', true);
				menu.setAttribute('aria-hidden', false);
				menu.classList.add('active');
			} else {
				// Close
				button.setAttribute('aria-expanded', false);
				menu.setAttribute('aria-hidden', true);
				menu.classList.remove('active');
			}
			// Add button
			button.addEventListener('click', function (e) {
				mobileNav.toggleSubmenu(e);
			});
			p.insertBefore(button, menu);
		});
	},

	// Toggle Sub Menus
	toggleSubmenu: function (e) {
		let button = e.target;
		let parent = button.parentNode;
		let menu = parent.querySelector('.sub-menu');
		if (!menu) {
			return false;
		}
		if (menu.classList.contains('active')) {
			// Close
			button.setAttribute('aria-expanded', false);
			menu.setAttribute('aria-hidden', true);
			menu.classList.remove('active');
		} else {
			// Open
			button.setAttribute('aria-expanded', true);
			menu.setAttribute('aria-hidden', false);
			menu.classList.add('active');
		}
	},

	/**
	 * Open the Menu
	 */
	open: function () {
		mobileNav.menuToggle.classList.add('open');
		mobileNav.menuToggle.setAttribute('aria-expanded', 'true');
		mobileNav.nav.classList.add('active');
		mobileNav.nav.setAttribute('aria-hidden', 'false');
		setTimeout(function () {
			mobileNav.wrap.classList.add('active');
			mobileNav.nav.focus();
			document.body.classList.add('mobile-menu-active');
		}, 250);
	},

	/**
	 * Close the Menu
	 */
	close: function () {
		mobileNav.wrap.classList.remove('active');
		setTimeout(function () {
			mobileNav.menuToggle.classList.remove('open');
			mobileNav.menuToggle.setAttribute('aria-expanded', 'false');
			mobileNav.menuToggle.focus();
			mobileNav.nav.classList.remove('active');
			mobileNav.nav.setAttribute('aria-hidden', 'true');
			document.body.classList.remove('mobile-menu-active');
		}, 250);
	},
};

if (mobileNav.subMenus) {
	mobileNav.setUpSubmenus(mobileNav.subMenus);
}

if (mobileNav.menuToggle) {
	// Toggle Click Event
	mobileNav.menuToggle.addEventListener('click', function (e) {
		if (mobileNav.menuToggle.classList.contains('open')) {
			mobileNav.close();
		} else {
			mobileNav.open();
		}
	});

	// Overlay Click
	mobileNav.nav.addEventListener('click', function (e) {
		if (e.target && e.target === mobileNav.nav) {
			mobileNav.close();
		}
	});

	// Close Button Click
	mobileNav.closeBtn.addEventListener('click', function (e) {
		mobileNav.close();
	});

	// Esc Close Event
	window.addEventListener('keyup', function (event) {
		if (event.keyCode == 27) {
			mobileNav.close();
		}
	});

	focusTrap(mobileNav.nav);
}

jQuery(document).ready(function ($) {
	$('#menu-primary-1 .menu-item-103 .a11ydrops-btn').keydown(function (e) {
		if (e.key === 'Tab') {
			e.preventDefault();
			if (e.shiftKey) {
				$('#menu-primary-1 .menu-item-103 > a').focus();
			} else {
				$('.mobile-nav--close').focus();
			}
		}
	});
	$('.tertiary-menu > li:nth-last-of-type(1) a').keydown(function (e) {
		if (e.key === 'Tab') {
			if (!e.shiftKey) {
				$(this)
					.closest('li')
					.parent()
					.closest('li')
					.find('.a11ydrops-btn')
					.click();
			}
		}
	});
	$('.tertiary-menu > li:nth-of-type(1) a').keydown(function (e) {
		if (e.key === 'Tab') {
			if (e.shiftKey) {
				$(this)
					.closest('li')
					.parent()
					.closest('li')
					.find('.a11ydrops-btn')
					.click();
			}
		}
	});
	$('.mobile-nav--close').keydown(function (e) {
		if (e.key === 'Tab') {
			e.preventDefault();
			if (e.shiftKey) {
				$('#menu-primary-1 .menu-item-103 .a11ydrops-btn').focus();
			} else {
				$('#menu-utility-1 .menu-item-6230 > a').focus();
			}
		}
	});
});
